import { useEffect } from 'react';

export const Hidden = ({ name, default_value, setValue }) => {
    useEffect(() => {
        setValue(name, default_value);
    }, []);
    return null;
};
